<template>
  <div>
    <!-- Vant 底部导航，fixed 固定在底部 -->
    <van-tabbar v-model="active" fixed @change="handleChange">
      <van-tabbar-item icon="wap-home" class="nav-item">首页</van-tabbar-item>
      <van-tabbar-item icon="todo-list" class="nav-item">球杆激活</van-tabbar-item>
      <van-tabbar-item icon="wechat-moments" class="nav-item">真伪查询</van-tabbar-item>
      <van-tabbar-item icon="friends" class="nav-item">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'FooterNav',
  data() {
    return {
      active: 0 // 默认选中首页
    };
  },
  methods: {
    // 切换导航触发路由跳转
    handleChange(index) {
      console.log(25,index);
      const routes = ['/app_home', '/app_activation', '/app_search', '/app_mine'];
      this.$router.push(routes[index]);
    }
  },
  watch: {
    // 路由同步导航选中状态
    '$route.path'(newPath) {
      const routes = ['/app_home', '/app_activation', '/app_search', '/app_mine'];
      this.active = routes.indexOf(newPath) || 0;
    }
  }
};
</script>

<style scoped lang="scss">
// 底部导航安全区适配
.van-tabbar {
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
// 导航项样式细化
.nav-item {
  font-size: 12px;
  .van-icon {
    font-size: 18px;
  }
}
</style>